module.exports = __webpack_public_path__ + "img/m_banner01_holidayathome-e.479ac9c3.jpg";